import { render, staticRenderFns } from "./BookingsSlotOpen.vue?vue&type=template&id=8ddf7f36&"
import script from "./BookingsSlotOpen.vue?vue&type=script&lang=js&"
export * from "./BookingsSlotOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports